import React from 'react';
import '../../App.css';
import Instagram from '../Instagram';
import Footer from '../Footer';

function Social() {
    return (
        <>
          <Instagram />
          <Footer />
        </>
      );
}

export default Social;